import captainInvoice from "./captainInvoice.component";
import captainInvoiceUrls from "./captainInvoice.urls";
import CaptainInvoiceTransforms from "./captainInvoice.transforms";

const captainInvoiceModule = angular
  .module("app.components.captainInvoice", [])
  .component("captainInvoicePage", captainInvoice)
  .service("CaptainInvoiceTransforms", CaptainInvoiceTransforms)
  .config(captainInvoiceUrls);

export default captainInvoiceModule;



// WEBPACK FOOTER //
// ./src/pages/captainInvoice/captainInvoice.module.js